import './App.css'
import './styles/general.css'
import 'react-toastify/dist/ReactToastify.css'

import LandingPage from './pages/landing'
import { ToastContainer } from 'react-toastify'

function App(): JSX.Element {
  return (
    <div className="App">
      <LandingPage />
      <ToastContainer
        position="top-right"
        className="toast-container"
        style={{
          width: '460px',
          height: '80px'
        }}
      />
    </div>
  )
}

export default App
